import { Theme } from "@mui/material/styles";
import { InputSelectIcon } from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Select(theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon,
      },

      styleOverrides: {
        select: {
          "&:focus": {
            borderColor: theme.palette.common.black,
            // Add any other styles for the focus state here
          },
        },
        outlined: {
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.common.black,
          },
        },
      },
    },
  };
}
